import axios from '../utils/axios';

const BASE = '/salesmen';

export const salesmanService = {
  list: async (params = {}) => {
    const { locationId } = params;
    const url = locationId != null ? `${BASE}/list?locationId=${locationId}` : `${BASE}/list`;
    const response = await axios.get(url);
    return response.data;
  },

  getAll: async (params = {}) => {
    const { page = 0, size = 25, locationId } = params;
    const query = new URLSearchParams({ page, size });
    if (locationId != null) query.set('locationId', locationId);
    const response = await axios.get(`${BASE}?${query.toString()}`);
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`${BASE}/${id}`);
    return response.data;
  },

  create: async (payload) => {
    const response = await axios.post(BASE, payload);
    return response.data;
  },

  update: async (id, payload) => {
    const response = await axios.put(`${BASE}/${id}`, payload);
    return response.data;
  },

  delete: async (id) => {
    await axios.delete(`${BASE}/${id}`);
  },
};

export default salesmanService;
